import React, { useMemo } from "react";
import usePopAlert2 from "./hooks/usePopAlert2";
import {
  DarkBackground,
  DialogBlock,
  ButtonGroup,
  Contents,
} from "components/styled/StyledModal";
import { Desktop, TabletAndMobile } from "components/utils/MediaQuery";

function PopAlert2() {
  const { state, onConfirm, onCancel } = usePopAlert2();
  const {
    title,
    description,
    confirmText,
    cancelText,
    visible,
    visibleCancel,
  } = state;

  if (!visible) return null;

  return (
    <>
      <Desktop>
        <DarkBackground onClick={onCancel}>
          <DialogBlock width={380} lineHeight={state.lineHeight}>
            {title && title.length > 0 && <h3>{title}</h3>}
            <Contents>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Contents>
            <ButtonGroup>
              {visibleCancel && (
                <button onClick={onCancel} className="CancelButton">
                  {cancelText}
                </button>
              )}
              <button onClick={onConfirm} className="ApplyButton">
                {confirmText}
              </button>
            </ButtonGroup>
          </DialogBlock>
        </DarkBackground>
      </Desktop>
      <TabletAndMobile>
        <DarkBackground onClick={onCancel}>
          <DialogBlock lineHeight={state.lineHeight} fontSize={state.fontSize}>
            {title && title.length > 0 && <h3>{title}</h3>}
            <Contents>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Contents>
            <ButtonGroup>
              {visibleCancel && (
                <button onClick={onCancel} className="CancelButton">
                  {cancelText}
                </button>
              )}
              <button onClick={onConfirm} className="ApplyButton">
                {confirmText}
              </button>
            </ButtonGroup>
          </DialogBlock>
        </DarkBackground>
      </TabletAndMobile>
    </>
  );
}

export default React.memo(PopAlert2);
